import { Region } from './region-model';
import { SelectorProvince } from './selector-province.model';

export class SelectorCountry extends SelectorProvince {
  constructor(
    public code: string,
    public name: string,
    public subTerritoriesCount?: number,
    public subnational?: SelectorProvince[],
    public hidden?: boolean,
    public altNames?: string[],
    public disabled?: boolean,
    public authDisabled?: boolean,
    public region?: string
  ) {
    super(code, name, disabled);
  }
}
